import { createVNode as _createVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "space-y-2" }, [
  /*#__PURE__*/_createVNode("div", { class: "text-12px xxl:text-14px pt-4 text-gray-lp-500 w-10/12" }, " Harga akan berlaku sesuai dengan tanggal periode yang dipilih. Harga Client mencakup harga normal & khusus. ")
], -1)
const _hoisted_2 = { class: "flex w-full mt-8" }
const _hoisted_3 = { class: "text-red-lp-100 text-12px xxl:text-14px" }
const _hoisted_4 = { class: "text-red-lp-100 text-12px xxl:text-14px" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_ModalForm = _resolveComponent("ModalForm")!

  return _withDirectives((_openBlock(), _createBlock(_component_ModalForm, {
    onClose: _ctx.onClose,
    onSubmit: _ctx.onSubmit,
    isLoading: _ctx.isLoading,
    title: 'Ubah Periode Harga',
    isScroll: false
  }, {
    content: _withCtx(() => [
      _hoisted_1,
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_DataWrapper, {
          label: "Dimulai Dari",
          class: "w-6/12 mt-4"
        }, {
          default: _withCtx(() => [
            _createVNode("div", {
              class: 
              ` mt-2 flex flex-row w-full ${_ctx.error.priceRateStartDate &&
                'date-error'}`
            
            }, [
              _createVNode(_component_DatePicker, {
                modelValue: new Date(_ctx.priceRateStartDate),
                onSelected: _ctx.startDateSelected,
                disabled: true
              }, null, 8, ["modelValue", "onSelected"])
            ], 2),
            _withDirectives(_createVNode("div", _hoisted_3, " Tanggal mulai tidak boleh lebih atau sama dengan tanggal akhir ", 512), [
              [_vShow, _ctx.error.priceRateStartDate]
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_DataWrapper, {
          label: "Sampai",
          class: "w-6/12 mt-4"
        }, {
          default: _withCtx(() => [
            _createVNode("div", {
              class: 
              `mt-2 flex flex-row w-full ${_ctx.error.priceRateEndDate &&
                'date-error'}`
            
            }, [
              _createVNode(_component_DatePicker, {
                modelValue: new Date(_ctx.priceRateEndDate),
                onSelected: _ctx.endDateSelected,
                minDate: _ctx.cachePriceRateEndDate
              }, null, 8, ["modelValue", "onSelected", "minDate"])
            ], 2),
            _withDirectives(_createVNode("div", _hoisted_4, " Tanggal akhir tidak boleh kurang atau sama dengan tanggal mulai ", 512), [
              [_vShow, _ctx.error.priceRateEndDate]
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["onClose", "onSubmit", "isLoading"])), [
    [_vShow, _ctx.ModalShow]
  ])
}